// libs
import React, { memo, useState, useEffect } from 'react';

// contexts
import DelayedRendererContext from './DelayedRendererContext';

// defs
interface IDelayedRendererProviderProps {
  children: React.ReactNode;
}

function DelayedRendererProvider({ children }: IDelayedRendererProviderProps) {
  const [canRenderComponent, setCanRenderComponent] = useState(false);

  // useEffect would be called once children is rendered
  useEffect(() => {
    // @ts-ignore
    const handle = window.requestIdleCallback(() => setCanRenderComponent(true), {
      timeout: 1000,
    });

    return () => {
      // @ts-ignore
      window.cancelIdleCallback(handle);
    };
  }, []);

  return (
    <DelayedRendererContext.Provider value={{ canRenderComponent }}>
      {children}
    </DelayedRendererContext.Provider>
  );
}

export default memo(DelayedRendererProvider);
